import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { handlePaginatedParameters } from "../_helpers/handle-parameters";
import { optionsWithDefaultsPaginated } from "../_helpers/options-with-defaults";
import { PaginatedOptions, UseQueryOptionsNoKeyAndFn } from "../_types";
import {
  ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_RESOURCE,
  ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_SEARCH_API_PATH,
  ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_SEARCH_OPERATION,
  type ElectronicSignatureTemplateConfigurationSearchBody,
  type ElectronicSignatureTemplateConfigurationSearchParameters,
  type ElectronicSignatureTemplateConfigurationSearchResponse,
} from "./electronic-signature-template-configuration.types";

export function useElectronicSignatureTemplateConfigurationSearchQuery({
  options,
  enabled,
  queryOptions,
}: {
  options?: PaginatedOptions<
    ElectronicSignatureTemplateConfigurationSearchParameters,
    ElectronicSignatureTemplateConfigurationSearchBody
  >;
  enabled?: boolean;
  queryOptions?: UseQueryOptionsNoKeyAndFn<
    ElectronicSignatureTemplateConfigurationSearchResponse,
    Error,
    ElectronicSignatureTemplateConfigurationSearchResponse,
    readonly unknown[]
  >;
} = {}) {
  const optionsWithDefaults =
    optionsWithDefaultsPaginated<
      PaginatedOptions<
        ElectronicSignatureTemplateConfigurationSearchParameters,
        ElectronicSignatureTemplateConfigurationSearchBody
      >
    >(options);
  const params = handlePaginatedParameters(optionsWithDefaults.parameters);
  const body = optionsWithDefaults.body;

  return useQuery({
    queryKey: [
      ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_RESOURCE,
      ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_SEARCH_OPERATION,
      { params, body },
    ],
    queryFn: async () => {
      const response = await alphartisApiAxios.post<ElectronicSignatureTemplateConfigurationSearchResponse>(
        ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_SEARCH_API_PATH,
        body,
        { params },
      );

      return response.data;
    },
    ...queryOptions,
    enabled,
  });
}
